var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Basic Dragdrop Example")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-1",
            modifiers: {
              "collapse-1": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-1"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "basic-dragdrop"
          }
        }, [_c('code', [_vm._v("\n<template>\n  <div class=\"row\">\n    <div class=\"col-12\">\n      <div class=\"form-group d-flex justify-content-between align-items-center\">\n        <div class=\"form-check\">\n          <input\n            id=\"disabled\"\n            type=\"checkbox\"\n            v-model=\"enabled\"\n            class=\"form-check-input\"\n          />\n          <label class=\"form-check-label\" for=\"disabled\">Drag and Drop enabled</label>\n        </div>\n        <div\n          class=\"buttons\"\n          aria-label=\"Basic example\"\n        >\n          <button class=\"btn btn-primary btn-sm\" @click=\"add\">Add</button>&nbsp;\n          <button class=\"btn btn-primary btn-sm\" @click=\"replace\">Replace</button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-12\">\n      <h5 class=\"mb-2\">Draggable</h5>\n\n      <draggable\n        :list=\"list\"\n        :disabled=\"!enabled\"\n        class=\"list-group\"\n        ghost-class=\"ghost\"\n        :move=\"checkMove\"\n        @start=\"dragging1 = true\"\n        @end=\"dragging1 = false\"\n      >\n        <div\n          class=\"list-group-item\"\n          v-for=\"element in list\"\n          :key=\"element.name\"\n        >\n        </div>\n      </draggable>\n    </div>\n  </div>\n</template>\n<script>\nimport draggable from 'vuedraggable'\nlet id = 1\nexport default {\n  name: 'DragDropDemo',\n  display:'DragDropDemo',\n  order: 0,\n  components: {\n  draggable\n  },\n  data(){\n    return {\n      enabled: true,\n      list: [\n        { name: \"John\", id: 0 },\n        { name: \"Joao\", id: 1 },\n        { name: \"Jean\", id: 2 }\n      ],\n      dragging: false\n    };\n  },\n  computed: {\n    draggingInfo() {\n      return this.dragging ? \"under drag\" : \"\";\n    }\n  },\n  methods: {\n    add () {\n      this.list.push({ name: \"Juan \" + id, id: id++ });\n    },\n    replace () {\n      this.list = [{ name: \"Edgard\", id: id++ }];\n    },\n    checkMove (e) {\n"), _vm._v("\n    }\n  }\n}\n</script>\n")])])])])]), [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "form-group d-flex justify-content-between align-items-center"
        }, [_c('div', {
          staticClass: "form-check"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.enabled,
            expression: "enabled"
          }],
          staticClass: "form-check-input",
          attrs: {
            "id": "disabled",
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(_vm.enabled) ? _vm._i(_vm.enabled, null) > -1 : _vm.enabled
          },
          on: {
            "change": function change($event) {
              var $$a = _vm.enabled,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.enabled = $$a.concat([$$v]));
                } else {
                  $$i > -1 && (_vm.enabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                }
              } else {
                _vm.enabled = $$c;
              }
            }
          }
        }), _c('label', {
          staticClass: "form-check-label",
          attrs: {
            "for": "disabled"
          }
        }, [_vm._v("Drag and Drop enabled")])]), _c('div', {
          staticClass: "buttons",
          attrs: {
            "aria-label": "Basic example"
          }
        }, [_c('button', {
          staticClass: "btn btn-primary btn-sm",
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Add")]), _vm._v("  "), _c('button', {
          staticClass: "btn btn-primary btn-sm",
          on: {
            "click": _vm.replace
          }
        }, [_vm._v("Replace")])])])])]), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('h5', {
          staticClass: "mb-2"
        }, [_vm._v("Draggable " + _vm._s(_vm.draggingInfo))]), _c('draggable', {
          staticClass: "list-group",
          attrs: {
            "list": _vm.list,
            "disabled": !_vm.enabled,
            "ghost-class": "ghost",
            "move": _vm.checkMove
          },
          on: {
            "start": function start($event) {
              _vm.dragging1 = true;
            },
            "end": function end($event) {
              _vm.dragging1 = false;
            }
          }
        }, _vm._l(_vm.list, function (element) {
          return _c('div', {
            key: element.name,
            staticClass: "list-group-item"
          }, [_vm._v(" " + _vm._s(element.name) + " ")]);
        }), 0)], 1)])]];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Two Lists Dragdrop Example")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-2",
            modifiers: {
              "collapse-2": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-2"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "two-lists-dragdrop"
          }
        }, [_c('code', [_vm._v("\n<template>\n  <div class=\"row\">\n    <div class=\"col-6\">\n      <h5 class=\"mb-2\">Draggable 1</h5>\n      <draggable class=\"list-group\" :list=\"list1\" group=\"people\" @change=\"log\">\n        <div\n          class=\"list-group-item\"\n          v-for=\"(element, index) in list1\"\n          :key=\"element.name\"\n        >\n        </div>\n      </draggable>\n    </div>\n\n    <div class=\"col-6\">\n      <h5 class=\"mb-2\">Draggable 2</h5>\n      <draggable class=\"list-group\" :list=\"list2\" group=\"people\" @change=\"log\">\n        <div\n          class=\"list-group-item\"\n          v-for=\"(element, index) in list2\"\n          :key=\"element.name\"\n        >\n        </div>\n      </draggable>\n    </div>\n  </div>\n</template>\n<script>\nimport draggable from 'vuedraggable'\nlet id = 1\nexport default {\n  name: 'DragDropDemo',\n  display:'DragDropDemo',\n  order: 0,\n  components: {\n  draggable\n  },\n  data(){\n    return {\n      enabled: true,\n      list1: [\n        { name: \"John\", id: 1 },\n        { name: \"Joao\", id: 2 },\n        { name: \"Jean\", id: 3 },\n        { name: \"Gerard\", id: 4 }\n      ],\n      list2: [\n        { name: \"Juan\", id: 5 },\n        { name: \"Edgard\", id: 6 },\n        { name: \"Johnson\", id: 7 }\n      ],\n      dragging: false\n    };\n  },\n  computed: {\n    draggingInfo() {\n      return this.dragging ? \"under drag\" : \"\";\n    }\n  },\n  methods: {\n    add () {\n      this.list.push({ name: \"Juan \" + id, id: id++ });\n    },\n    replace () {\n      this.list = [{ name: \"Edgard\", id: id++ }];\n    },\n    checkMove (e) {\n"), _vm._v("\n    }\n  }\n}\n</script>\n")])])])])]), [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-6"
        }, [_c('h5', {
          staticClass: "mb-2"
        }, [_vm._v("Draggable 1")]), _c('draggable', {
          staticClass: "list-group",
          attrs: {
            "list": _vm.list1,
            "group": "people"
          },
          on: {
            "change": _vm.log
          }
        }, _vm._l(_vm.list1, function (element, index) {
          return _c('div', {
            key: element.name,
            staticClass: "list-group-item"
          }, [_vm._v(" " + _vm._s(element.name) + " " + _vm._s(index) + " ")]);
        }), 0)], 1), _c('div', {
          staticClass: "col-6"
        }, [_c('h5', {
          staticClass: "mb-2"
        }, [_vm._v("Draggable 2")]), _c('draggable', {
          staticClass: "list-group",
          attrs: {
            "list": _vm.list2,
            "group": "people"
          },
          on: {
            "change": _vm.log
          }
        }, _vm._l(_vm.list2, function (element, index) {
          return _c('div', {
            key: element.name,
            staticClass: "list-group-item"
          }, [_vm._v(" " + _vm._s(element.name) + " " + _vm._s(index) + " ")]);
        }), 0)], 1)])]];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Transitions Dragdrop Example")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-5",
            modifiers: {
              "collapse-5": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-5"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "transitions-dragdrop"
          }
        }, [_c('code', [_vm._v("\n<template>\n  <div class=\"row\">\n    <div class=\"col-12\">\n      <button class=\"btn btn-primary\" @click=\"sort\">\n        To original order\n      </button>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-12\">\n      <h5>Transition</h5>\n      <draggable\n          class=\"list-group\"\n          tag=\"ul\"\n          v-model=\"transitionList\"\n          v-bind=\"dragOptions\"\n          @start=\"drag = true\"\n          @end=\"drag = false\">\n        <transition-group type=\"transition\" :name=\"!drag ? 'flip-list' : null\">\n          <li class=\"list-group-item\" v-for=\"element in transitionList\" :key=\"element.order\">\n            <i :class=\" element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin' \" @click=\"element.fixed = !element.fixed\" aria-hidden=\"true\" ></i>\n          </li>\n        </transition-group>\n      </draggable>\n    </div>\n  </div>\n</template>\n<script>\nimport draggable from 'vuedraggable'\nconst message = [\n  \"vue.draggable\",\n  \"draggable\",\n  \"component\",\n  \"for\",\n  \"vue.js 2.0\",\n  \"based\",\n  \"on\",\n  \"Sortablejs\"\n];\nexport default {\n  name: 'DragDropDemo',\n  display:'DragDropDemo',\n  order: 0,\n  components: {\n    draggable\n  },\n  data(){\n    return {\n      transitionList: message.map((name, index) => {\n        return { name, order: index + 1 };\n      }),\n      drag: false\n    },\n  }\n  computed: {\n    draggingInfo() {\n      return this.dragging ? \"under drag\" : \"\";\n    }\n  },\n  methods: {\n    sort () {\n      this.transitionList = this.transitionList.sort((a, b) => a.order - b.order)\n    }\n  }\n}\n</script>\n")])])])])]), [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('h5', {
          staticClass: "mb-2"
        }, [_vm._v("Transition")]), _c('button', {
          staticClass: "btn btn-primary btn-sm mb-2",
          on: {
            "click": _vm.sort
          }
        }, [_vm._v(" To original order ")])]), _c('draggable', _vm._b({
          staticClass: "list-group",
          attrs: {
            "tag": "ul"
          },
          on: {
            "start": function start($event) {
              _vm.drag = true;
            },
            "end": function end($event) {
              _vm.drag = false;
            }
          },
          model: {
            value: _vm.transitionList,
            callback: function callback($$v) {
              _vm.transitionList = $$v;
            },
            expression: "transitionList"
          }
        }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
          attrs: {
            "type": "transition",
            "name": !_vm.drag ? 'flip-list' : null
          }
        }, _vm._l(_vm.transitionList, function (element) {
          return _c('li', {
            key: element.order,
            staticClass: "list-group-item"
          }, [_c('i', {
            class: element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin',
            attrs: {
              "aria-hidden": "true"
            },
            on: {
              "click": function click($event) {
                element.fixed = !element.fixed;
              }
            }
          }), _vm._v(" " + _vm._s(element.name) + " ")]);
        }), 0)], 1)], 1)])]];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Table Column Dragdrop Example")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-6",
            modifiers: {
              "collapse-6": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-6"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "table-column-dragdrop"
          }
        }, [_c('code', [_vm._v("\n<template>\n  <div class=\"row\">\n    <div class=\"col-8\">\n    <h5>Draggable table</h5>\n    <table class=\"table table-striped\">\n      <thead class=\"thead-dark\">\n        <draggable v-model=\"headers\" tag=\"tr\">\n          <th v-for=\"header in headers\" :key=\"header\" scope=\"col\">\n          </th>\n        </draggable>\n      </thead>\n    <tbody>\n      <tr v-for=\"item in list5\" :key=\"item.name\">\n        <td v-for=\"header in headers\" :key=\"header\">\n        </td>\n      </tr>\n    </tbody>\n    </table>\n    </div>\n  </div>\n</template>\n<script>\nimport draggable from 'vuedraggable'\n\nexport default {\n  name: 'DragDropDemo',\n  display:'DragDropDemo',\n  order: 0,\n  components: {\n    draggable\n  },\n  data(){\n    return {\n      headers: [\"id\", \"name\", \"sport\"],\n      list: [\n        { id: 1, name: \"Abby\", sport: \"basket\" },\n        { id: 2, name: \"Brooke\", sport: \"foot\" },\n        { id: 3, name: \"Courtenay\", sport: \"volley\" },\n        { id: 4, name: \"David\", sport: \"rugby\" }\n      ],\n      dragging: false\n    }\n  }\n}\n</script>\n")])])])])]), [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('h5', {
          staticClass: "mb-2"
        }, [_vm._v("Draggable table")]), _c('table', {
          staticClass: "table table-striped"
        }, [_c('thead', {
          staticClass: "thead-dark"
        }, [_c('draggable', {
          attrs: {
            "tag": "tr"
          },
          model: {
            value: _vm.headers,
            callback: function callback($$v) {
              _vm.headers = $$v;
            },
            expression: "headers"
          }
        }, _vm._l(_vm.headers, function (header) {
          return _c('th', {
            key: header,
            attrs: {
              "scope": "col"
            }
          }, [_c('i', {
            staticClass: "fas fa-arrows-alt"
          }), _vm._v(_vm._s(header) + " ")]);
        }), 0)], 1), _c('tbody', _vm._l(_vm.list5, function (item) {
          return _c('tr', {
            key: item.name
          }, _vm._l(_vm.headers, function (header) {
            return _c('td', {
              key: header
            }, [_vm._v(_vm._s(item[header]))]);
          }), 0);
        }), 0)])])])]];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Custom Clone Dragdrop Example")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-3",
            modifiers: {
              "collapse-3": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-3"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "custom-clone-dragdrop"
          }
        }, [_c('code', [_vm._v("\n<template>\n  <div class=\"row\">\n      <div class=\"col-6\">\n        <h5 class=\"mb-2\">Draggable 1</h5>\n        <draggable\n          class=\"dragArea list-group\"\n          :list=\"list3\"\n          :group=\"{ name: 'people', pull: 'clone', put: false }\"\n          :clone=\"cloneDog\"\n          @change=\"log\"\n        >\n          <div class=\"list-group-item\" v-for=\"element in list3\" :key=\"element.id\">\n          </div>\n        </draggable>\n      </div>\n\n      <div class=\"col-6\">\n        <h5 class=\"mb-2\">Draggable 2</h5>\n        <draggable\n          class=\"dragArea list-group\"\n          :list=\"list4\"\n          group=\"people\"\n          @change=\"log\"\n        >\n          <div class=\"list-group-item\" v-for=\"element in list4\" :key=\"element.id\">\n          </div>\n        </draggable>\n      </div>\n    </div>\n</template>\n<script>\nimport draggable from 'vuedraggable'\nlet idGlobal = 8\nexport default {\n  name: 'DragDropDemo',\n  display:'DragDropDemo',\n  order: 0,\n  components: {\n    draggable\n  },\n  data(){\n    return {\n      enabled: true,\n      list3: [\n        { name: 'dog 1', id: 1 },\n        { name: 'dog 2', id: 2 },\n        { name: 'dog 3', id: 3 },\n        { name: 'dog 4', id: 4 }\n      ],\n      list4: [\n        { name: 'cat 5', id: 5 },\n        { name: 'cat 6', id: 6 },\n        { name: 'cat 7', id: 7 }\n      ],\n      dragging: false\n    };\n    },\n    computed: {\n      draggingInfo() {\n        return this.dragging ? \"under drag\" : \"\";\n      }\n    },\n    methods: {\n      cloneDog  ({ id }) {\n      return {\n        id: idGlobal++,\n        name: `cat ${id}`\n    }\n  }\n}\n</script>\n")])])])])]), [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-6"
        }, [_c('h5', {
          staticClass: "mb-2"
        }, [_vm._v("Draggable 1")]), _c('draggable', {
          staticClass: "dragArea list-group",
          attrs: {
            "list": _vm.list3,
            "group": {
              name: 'people',
              pull: 'clone',
              put: false
            },
            "clone": _vm.cloneDog
          },
          on: {
            "change": _vm.log
          }
        }, _vm._l(_vm.list3, function (element) {
          return _c('div', {
            key: element.id,
            staticClass: "list-group-item"
          }, [_vm._v(" " + _vm._s(element.name) + " ")]);
        }), 0)], 1), _c('div', {
          staticClass: "col-6"
        }, [_c('h5', {
          staticClass: "mb-2"
        }, [_vm._v("Draggable 2")]), _c('draggable', {
          staticClass: "dragArea list-group",
          attrs: {
            "list": _vm.list4,
            "group": "people"
          },
          on: {
            "change": _vm.log
          }
        }, _vm._l(_vm.list4, function (element) {
          return _c('div', {
            key: element.id,
            staticClass: "list-group-item"
          }, [_vm._v(" " + _vm._s(element.name) + " ")]);
        }), 0)], 1)])]];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Nested Dragdrop Example")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-4",
            modifiers: {
              "collapse-4": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-4"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "handle-dragdrop"
          }
        }, [_c('code', [_vm._v("\n<template>\n  <nested-draggable :tasks=\"nestedList\" />\n</template>\n<script>\nimport NestedDraggable from '@component/xray/dragdrop/nested-draggable'\nexport default{\n  components: { NestedDraggable },\n  data () {\n    return {\n      nestedList: [\n        {\n          name: 'task 1',\n          tasks: [\n            {\n              name: 'task 2',\n              tasks: []\n            }\n          ]\n        },\n        {\n          name: 'task 3',\n          tasks: [\n            {\n              name: 'task 4',\n              tasks: []\n            }\n          ]\n        },\n        {\n          name: 'task 5',\n          tasks: []\n        }\n      ]\n    }\n  }\n}\n</script>\n")])])])])]), [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('h5', {
          staticClass: "mb-2"
        }, [_vm._v("Nested Draggable")]), _c('nested-draggable', {
          attrs: {
            "tasks": _vm.nestedList
          }
        })], 1)])]];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }